export default __webpack_public_path__ + "static/media/apostar_icons_eingabe_2_personal.bed82a4d.svg";